/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Client module `corporateIdentityUtils` for the Caintra Connect frontend.
 * @module utils/corporateIdentityUtils
 *
 * Conventions:
 * - Keep components focused on rendering; move branching logic into hooks or utils.
 * - Prefer named exports for helpers and default exports for React components.
 * - Reuse shared validation, i18n, and API helpers from client/src/utils and logic/.
 */

const LOGO_ALLOWED_TYPES = ["image/jpeg", "image/jpg", "image/png"];
const LOGO_MAX_SIZE_BYTES = 5 * 1024 * 1024;

export const validateLogoFile = (file, t) => {
  if (!LOGO_ALLOWED_TYPES.includes(file.type)) {
    return t("components.corporateIdentity.logoFileTypeError");
  }
  if (file.size > LOGO_MAX_SIZE_BYTES) {
    return t("components.corporateIdentity.logoFileSizeError");
  }
  return "";
};

export const buildEmptyDescriptions = () => ({
  es: "",
  en: "",
  fr: "",
});

export const normalizeCompanyDescriptions = (companyDescriptions) => {
  const descriptions = { ...(companyDescriptions || {}) };
  for (const lang of ["es", "en", "fr"]) {
    if (!descriptions[lang]) {
      descriptions[lang] = "";
    }
  }
  return descriptions;
};
